import React from "react";
import MultiViewContainer from "../components/multi-view/MultiView";

function MultiView() {
  return <MultiViewContainer />;
}

export default MultiView;
